import React from 'react';

/**
 * Componente: PrivacyPolicyPage (/pages/PrivacyPolicyPage.jsx)
 * Página da Política de Privacidade
 */
const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Política de Privacidade</h1>
        
        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Informações que Coletamos</h2>
            <p>
              A Barberize coleta as seguintes informações:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Dados de Cadastro:</strong> Nome, e-mail, telefone e tipo de conta (Cliente ou Dono de Barbearia)</li>
              <li><strong>Dados de Agendamento:</strong> Informações sobre horários, serviços e barbearias</li>
              <li><strong>Dados de Integração:</strong> Ao conectar o Google Calendar, coletamos tokens de acesso para sincronização automática de eventos</li>
              <li><strong>Dados de Uso:</strong> Informações sobre como você usa nossa plataforma</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">2. Como Usamos Suas Informações</h2>
            <p>Utilizamos suas informações para:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Processar e gerenciar agendamentos</li>
              <li>Enviar notificações e confirmações por e-mail</li>
              <li>Sincronizar eventos com o Google Calendar (quando autorizado)</li>
              <li>Melhorar nossos serviços e experiência do usuário</li>
              <li>Comunicar atualizações importantes sobre a plataforma</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">3. Integração com Google Calendar</h2>
            <p>
              Quando você conecta sua conta do Google Calendar:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Solicitamos permissão para acessar e gerenciar eventos do seu calendário</li>
              <li>Criamos, atualizamos e excluímos eventos automaticamente conforme seus agendamentos</li>
              <li>Armazenamos tokens de acesso de forma segura no Firebase</li>
              <li>Você pode desconectar a qualquer momento na aba "Integrações"</li>
              <li>Ao desconectar, todos os tokens são removidos permanentemente</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">4. Compartilhamento de Dados</h2>
            <p>
              Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Quando necessário para processar agendamentos (compartilhamento entre cliente e barbearia)</li>
              <li>Com o Google Calendar API (apenas quando você autoriza a integração)</li>
              <li>Quando exigido por lei ou ordem judicial</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">5. Segurança dos Dados</h2>
            <p>
              Implementamos medidas de segurança para proteger suas informações:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Autenticação segura via Firebase Authentication</li>
              <li>Armazenamento criptografado no Firebase Firestore</li>
              <li>Tokens OAuth protegidos e com prazo de validade</li>
              <li>Conexões HTTPS em todas as comunicações</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">6. Seus Direitos (LGPD)</h2>
            <p>De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Confirmar a existência de tratamento de dados</li>
              <li>Acessar seus dados pessoais</li>
              <li>Corrigir dados incompletos, inexatos ou desatualizados</li>
              <li>Solicitar a anonimização, bloqueio ou eliminação de dados</li>
              <li>Solicitar a portabilidade dos dados</li>
              <li>Revogar consentimento a qualquer momento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">7. Retenção de Dados</h2>
            <p>
              Mantemos seus dados enquanto sua conta estiver ativa. Ao excluir sua conta, 
              todos os seus dados pessoais serão removidos permanentemente, exceto aqueles 
              que precisamos manter por obrigação legal.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">8. Cookies e Tecnologias Similares</h2>
            <p>
              Utilizamos cookies e tecnologias similares para melhorar sua experiência, 
              incluindo autenticação de sessão e preferências do usuário.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">9. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos 
              sobre mudanças significativas por e-mail ou por aviso na plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">10. Contato</h2>
            <p>
              Para questões sobre privacidade ou exercer seus direitos, entre em contato:
            </p>
            <ul className="list-none mt-2 space-y-1">
              <li><strong>E-mail:</strong> barberizeapp01@gmail.com</li>
              <li><strong>WhatsApp:</strong> (32) 99905-2029</li>
            </ul>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-300 text-sm text-gray-600">
            <p><strong>Última atualização:</strong> 20 de novembro de 2025</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
